import { jsx as _jsx } from "react/jsx-runtime";
import { memo } from 'react';
import PasswordField from './PasswordField';
import { DefaultTextField } from './styled';
const InputField = ({ type, disableFieldset, backgroundColor, ...props }) => type === 'password' ? (_jsx(PasswordField, { "$disableFieldset": disableFieldset, "$backgroundColor": backgroundColor, ...props })) : (_jsx(DefaultTextField, { "$disableFieldset": disableFieldset, "$backgroundColor": backgroundColor, type: type, ...props }));
export default memo(InputField);
